module.exports = __webpack_public_path__ + "static/media/Diversity.e4290671.png";